import { TransportTypeEnum, TripTypeEnum } from '../trip/trip-type.enum'

type TripFolderTypeMapping = Record<
  TripFolderTypeEnum,
  { directionality: TransportTypeEnum; tripType: TripTypeEnum }
>

export enum TripFolderTypeEnum {
  MAIN_ONE_WAY = 'MAIN_ONE_WAY',
  MAIN_RETURN = 'MAIN_RETURN',
  SECONDARY_ONE_WAY = 'SECONDARY_ONE_WAY',
  SECONDARY_RETURN = 'SECONDARY_RETURN'
}

export const tripFolderTypeMapping: TripFolderTypeMapping = {
  [TripFolderTypeEnum.MAIN_ONE_WAY]: {
    directionality: TransportTypeEnum.ONE_WAY,
    tripType: TripTypeEnum.PRIMARY
  },
  [TripFolderTypeEnum.MAIN_RETURN]: {
    directionality: TransportTypeEnum.RETURN,
    tripType: TripTypeEnum.PRIMARY
  },
  [TripFolderTypeEnum.SECONDARY_ONE_WAY]: {
    directionality: TransportTypeEnum.ONE_WAY,
    tripType: TripTypeEnum.SECONDARY
  },
  [TripFolderTypeEnum.SECONDARY_RETURN]: {
    directionality: TransportTypeEnum.RETURN,
    tripType: TripTypeEnum.SECONDARY
  }
}
